import type React from 'react';

import { Field } from 'react-final-form';

import { NativeSelect } from '#src/app/shared/components/adminShadcn';

import { filterValueValidator } from '../../../../../../../shared/validators';

export const SelectField: React.FC<{
	fieldName: string;
	fieldValues: readonly string[];
	placeholder: string;
}> = ({ fieldName, fieldValues, placeholder }) => {
	return (
		<Field<string | undefined> name={fieldName} validate={filterValueValidator}>
			{({ input, meta }) => (
				<div className="admin:flex-1 admin:[&_[data-slot=native-select-wrapper]]:w-full">
					<NativeSelect
						value={input.value ?? ''}
						name={input.name}
						onChange={input.onChange}
						aria-invalid={meta.touched && meta.error ? true : undefined}
					>
						<option value="">{placeholder}</option>
						{fieldValues.map((value) => (
							<option key={value} value={value}>
								{value}
							</option>
						))}
					</NativeSelect>
					{meta.touched && meta.error ? (
						<p role="alert" className="admin:mt-1 admin:text-xs admin:text-destructive">
							{meta.error as string}
						</p>
					) : null}
				</div>
			)}
		</Field>
	);
};
